import { fetcher } from '@commenda/utils';

export type ExtendComplianceFilingsParams = {
  complianceItemIds: string[];
  newDueDate: string;
  reasonForExtension?: string;
};

export type ExtendComplianceFilingsResponse = {
  extendedCount: number;
};

export type ExtendComplianceFilingsResult = {
  success: boolean;
  data?: ExtendComplianceFilingsResponse;
  error?: string;
  statusCode?: number;
};

export async function extendComplianceFilings({
  complianceItemIds,
  newDueDate,
  reasonForExtension,
}: ExtendComplianceFilingsParams): Promise<ExtendComplianceFilingsResult> {
  try {
    const response = await fetcher('compliance/bulk/extend', {
      method: 'POST',
      body: { complianceItemIds, newDueDate, reasonForExtension },
    });

    if (!response.ok) {
      const responseData = await response.json().catch(() => null);
      return {
        success: false,
        error: responseData?.message ?? 'Failed to extend filings',
        statusCode: response.status,
      };
    }

    const responseData: ExtendComplianceFilingsResponse = await response.json();
    return { success: true, data: responseData };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to extend filings';
    return { success: false, error: errorMessage, statusCode: 500 };
  }
}
